import { createAction, props } from '@ngrx/store';

import {
  CreateInvitiationFormModel
} from 'account/components/account-create/account-create.component';

export const OPEN_CREATE_ACCOUNT_DIALOG = createAction(
  '[Account] OPEN_CREATE_ACCOUNT_DIALOG',
  props<{ payload: CreateInvitiationFormModel }>()
);

export const ACCOUNT_ADDED_FROM_DIALOG = createAction(
  '[Account] ACCOUNT_ADDED_FROM_DIALOG',
  props<{
    payload: {
      user: {
        id: string;
        linkedEntityId?: string;
      };
    };
  }>()
);
